import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=05089ce4&scoped=true&"
import script from "./Widget.vue?vue&type=script&lang=js&"
export * from "./Widget.vue?vue&type=script&lang=js&"
import style0 from "./Widget.vue?vue&type=style&index=0&id=05089ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05089ce4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle})
